<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row wrap style="padding:15px">
                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                          readonly
                          v-model="form.email"
                          append-icon="mark_email_read"
                          label="Email ID"
                          type="text"
                          :rules="[rules.emailid]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                      readonly
                          v-model="form.mobileNumber"
                          append-icon="call"
                          label="Mobile number"
                          type="number"
                          min="0"
                          :rules="[rules.mobileno]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                      readonly
                          v-model="form.destination"
                          label="Destination(s)"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                      readonly
                          v-model="form.startingFrom"
                          label="Starting From"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                      readonly
                          v-model="form.startDate"
                          label="Starting From"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                    <v-text-field
                    readonly
                          v-model="form.duration"
                          label="Trip Duration"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6> 
                      <v-text-field
                      readonly
                          v-model="form.budget"
                          label="Approximate Budget"
                          type="Number"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px"> 
                      <v-text-field
                      readonly
                          v-model="form.adult"
                          label="(Adults: 12+ Yrs)"
                          type="Number"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px"> 
                      <v-text-field
                      readonly
                          v-model="form.children"
                          label="(Child: 2-12 Yrs)"
                          type="Number"
                          ></v-text-field>
                    </v-flex>


                    <v-flex xs12 sm12 md4 style="padding-right:5px">
                         <v-text-field
                         readonly
                          v-model="form.transportation"
                          label="Transportation"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md4> 
                     <v-text-field
                     readonly
                          v-model="form.accommodation"
                          label="Accommodations"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                         readonly
                         :rows="3"
                          v-model="form.notes"
                          label="Notes / Special Requirements"
                          ></v-textarea>
                    </v-flex>

                    <v-flex xs12>
                      <b-form-checkbox :disabled="true" v-model="form.need">Need transportation from my Starting City</b-form-checkbox>
                    </v-flex>
                  </v-layout>
                </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "View Enquiry",
      edit: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },
      valid: true,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Enquiry",
          disabled: false,
          to: "/enquiry"
        },
        {
          text: "View Enquiry",
          disabled: true,
          to: "/viewEnquiry"
        }
      ],

      form: null
    };
  },

  mounted() {

      this.axios
      .get(config.API + `Enquiries/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
      })
      .catch(err => {
        console.log(err.message);
      });
    },
    

  methods: {
    back() {
      this.$router.go(-1);
    },

    

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `TourThemes/${this.$route.params.id}`,
            {
              id: this.$route.params.id,
              name: this.form.name,
              description: this.form.description,
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Tour Theme updated successful");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
</style>
